import { render } from "./tongzhi.vue?vue&type=template&id=50fbdced"
import script from "./tongzhi.vue?vue&type=script&lang=js"
export * from "./tongzhi.vue?vue&type=script&lang=js"

import "./tongzhi.vue?vue&type=style&index=0&id=50fbdced&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__